import React from "react";

const CustomSelect = ({ id, label, value, options, isInvalid, onChange,required }) => {
  const locationTypes = ["country", "state", "city"];
  return (
    <div className="grid w-full max-w-sm items-center gap-1.5">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label} {required &&<span className="text-red-500">*</span>}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(id, e.target.value,e.target.selectedOptions[0])}
        className={`block w-full pl-3 pr-10 py-2 text-base border ${
          isInvalid ? "border-red-500 shadow-md shadow-red-400/30" : "border-gray-300"
        } rounded-md focus:outline-none focus:shadow-md focus:border-brand-500 focus:shadow-brand-500/30`}
      >
        <option value="">Select {label}</option>
        {options.map((option) => {
          if (locationTypes.includes(id)) {
            return (
              <option key={option.id} value={option.name} id={option.id}>
                {option.name}
              </option>
            );
          }
           else {
            return (
              <option key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </option>
            );
          }
        })}
      </select>
      {isInvalid && <p className="mt-[2px] text-[12px] text-red-700">{isInvalid}</p>}
    </div>
  );
};

export default CustomSelect;
